import { theme } from '@/styles/theme';

export const styles = {
  text: {
    whiteSpace: 'pre-line',
    fontWeight: 600,
    fontSize: '20px',
    color: theme.palette.primary.main,
    paddingTop: '32px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      paddingTop: '24px',
    },
  },
  minContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: theme.spacing(2),
  },
  minContent: {
    backgroundColor: theme.palette.secondary.contrastText,
    borderRadius: 2,
    boxShadow: 1,
    paddingInline: 4,
    marginTop: 4,
    paddingBlock: 4,
  },
};
